import axios from "axios";

// Local axios instance
const LAxios = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 30 * 60 * 60 * 1000,
  headers: { Content: "Application/json" },
});

LAxios.interceptors.request.use((config) => {
  config.headers["x-token"] = localStorage.getItem("xToken");
  if (!config.headers["Authorization"]) {
    const token = sessionStorage.getItem(process.env.REACT_APP_TOKEN as string);
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
  }
  return config;
});

export { LAxios };
